import * as React from 'react';

export const CianAssistIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48">
    <path
      fill="#2E9E00"
      // tslint:disable-next-line:max-line-length
      d="M46.9 22.59l-5.36-5.42V8c0-1.1-.88-2-1.98-2H30.5L25.14.58a1.96 1.96 0 0 0-2.8 0L16.98 6H7.91a1.99 1.99 0 0 0-1.97 2v9.17L.58 22.6a2.01 2.01 0 0 0 0 2.82l5.36 5.42V40c0 1.1.88 2 1.97 2h9.07l5.36 5.41a1.96 1.96 0 0 0 2.8 0l5.35-5.4h9.07a1.99 1.99 0 0 0 1.98-2v-9.18l5.36-5.42a2.01 2.01 0 0 0 0-2.82z"
    />
    <path
      fill="#FFF"
      transform="translate(14.3 10.18)"
      // tslint:disable-next-line:max-line-length
      d="M9.84 5.72l.04.1 3.37 6.02 3.37-6.03.05-.1c.3-.54.46-1.15.47-1.78 0-1.63-.99-3.09-2.48-3.67A3.82 3.82 0 0 0 10.4 1.3a3.98 3.98 0 0 0-.56 4.42zm3.44-3.52a1.73 1.73 0 0 1 1.6 1.1 1.78 1.78 0 0 1-.4 1.92 1.7 1.7 0 0 1-1.89.36 1.76 1.76 0 0 1-1.05-1.65c.02-.96.8-1.73 1.74-1.73zm1.46 16.44l2.47 2.52-3.08 3.13-5.41-5.52-5.42 5.52-3.08-3.13 8.5-8.64 3.1 3.16v-2.85h2.92v5.81z"
    />
  </svg>
);
